import script from "./TransferTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferTemplate.vue?vue&type=script&setup=true&lang=js"

import "./TransferTemplate.vue?vue&type=style&index=0&id=c7c07142&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7c07142"]])

export default __exports__